const defaultSettings = {
    animationAttibute: 'data-aos',
    reverseAttribute: 'data-aos-reverse',
    thresholdAttribute: 'data-aos-threshold',
    rootMarginAttribute: 'data-aos-rootmargin',
};
class AOS {
    constructor(settings = {}) {
        this.defaultOptions = {
            threshold: 0.6,
            rootMargin: '0px',
        };
        this.createObserver = (element, options) => {
            const observer = new IntersectionObserver(entries => this.handleEntries(entries), options);
            observer.observe(element);
        };
        /* handle entries run when a new element is observed (comes into view) */
        this.handleEntries = (entries) => {
            entries.forEach(entry => {
                const cssClass = entry.target.getAttribute(this.settings.animationAttibute);
                const reverse = entry.target.getAttribute(this.settings.reverseAttribute) !== null;
                if (cssClass === null) {
                    return;
                }
                if (!entry.isIntersecting) {
                    if (reverse) {
                        entry.target.classList.remove(cssClass);
                    }
                    return;
                }
                entry.target.classList.add(cssClass);
            });
        };
        this.settings = {
            ...defaultSettings,
            ...settings,
        };
        const elements = Array.from(document.querySelectorAll(`[${this.settings.animationAttibute}]`));
        if (elements.length === 0) {
            return;
        }
        elements.forEach(element => {
            const options = { ...this.defaultOptions };
            const threshold = parseFloat(element.getAttribute(this.settings.thresholdAttribute) || '');
            const rootMargin = element.getAttribute(this.settings.rootMarginAttribute);
            if (!isNaN(threshold) && threshold < 1.0) {
                options.threshold = threshold;
            }
            if (rootMargin !== null && rootMargin.length > 0) {
                options.rootMargin = rootMargin;
            }
            this.createObserver(element, options);
        });
    }
}
export default AOS;
